module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 18c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zM9 1.5C4.865 1.5 1.5 4.865 1.5 9s3.365 7.5 7.5 7.5 7.5-3.365 7.5-7.5S13.135 1.5 9 1.5zm0 12.75a.789.789 0 0 1-.533-.217.785.785 0 0 1-.217-.533c0-.202.082-.39.217-.533.278-.277.78-.277 1.066 0 .135.143.217.33.217.533 0 .195-.082.39-.217.533A.789.789 0 0 1 9 14.25zm0-3a.75.75 0 0 1-.75-.75v-6a.75.75 0 1 1 1.5 0v6a.75.75 0 0 1-.75.75z\" fill=\"#E6314F\" fill-rule=\"nonzero\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/status-icon-danger.svg
// module id = 95qH
// module chunks = 89